import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import { ProjectActivityContext } from 'components/contexts/ProjectActivityContext';
import ProjectActivityTab from 'components/projectActivity/components/ProjectActivityTab';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectActivityContext.Provider value={wrappedProps}>
          <ProjectActivityTab />
        </ProjectActivityContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}
